import { type TemplateResult, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { TailwindElement } from '../../shared/tailwind.element';
import { questionaireContext } from '../../context/context';
import { consume } from '@lit/context';
import { type QuestionaireData } from '../../interfaces/interfaces';

@customElement('szw-ba-progress-bar')
export class SzwBaProgressBar extends TailwindElement() {
	@consume({ context: questionaireContext, subscribe: true })
	@property({ attribute: false })
	data!: QuestionaireData;

	connectedCallback(): void {
		super.connectedCallback();
	}

	getProgress(): number {
		const progress = this.data?.canOpenReport && this.data?.question == null ? 100 : this.data?.question?.progress ?? 0;
		return Math.floor(progress);
	}

	render(): TemplateResult {
		return html`
			${this.data?.question != null || this.data?.canOpenReport
				? html` <div class="mx-auto mb-6 flex max-w-3xl items-center gap-4 px-6 print:hidden">
						<progress
							id="progress"
							aria-labelledby="progress-label"
							class="w-full overflow-hidden progress-unfilled:rounded-full progress-unfilled:bg-donkerblauw-15 progress-filled:rounded-full progress-filled:bg-donkerblauw-100"
							value="${this.getProgress()}"
							role="status"
							aria-valuemin="0"
							aria-valuetext="De voortgang is nu ${this.getProgress()} procent."
							aria-valuenow="${this.getProgress()}"
							aria-valuemax="100"
							max="100"
						></progress>
						<label
							for="progress"
							id="progress-label"
							class="block w-[5ch] text-right font-bold text-donkerblauw-100"
							aria-label="De voortgang is nu ${this.getProgress()} procent."
							>${this.getProgress()}%</label
						>
				  </div>`
				: null}
		`;
	}
}

declare global {
	interface HTMLElementTagNameMap {
		'szw-ba-progress-bar': SzwBaProgressBar;
	}
}
